/** Values returned in API `nextChallenge` (login / enroll). */
export const NEXT_CHALLENGE = {
  NONE: "NONE",
  EMAIL_OTP: "EMAIL_OTP",
  MFA_REQUIRED: "MFA_REQUIRED",
  NEW_PASSWORD_REQUIRED: "NEW_PASSWORD_REQUIRED",
  MFA_SETUP_REQUIRED: "MFA_SETUP_REQUIRED",
};

/** Optional disambiguation for MFA_REQUIRED (Cognito challenge family). */
export const COGNITO_MFA_CHALLENGE = {
  SOFTWARE_TOKEN_MFA: "SOFTWARE_TOKEN_MFA",
  SMS_MFA: "SMS_MFA",
};

/** `GET /auth/v1/mfa` — same codes as `msp_auth_config.mfa_method`. */
export const TENANT_MFA_MODE = {
  EMAIL: 0,
  TOTP: 1,
  SMS: 2,
  NONE: 3,
};
